// Validate min value
export function MinValueValidatorDirective() {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$validators.minValue = function (inputValue) {
        // console.log(parseFloat(attrs.minValueValidator));
        // console.log(parseFloat(inputValue));

        if (
          inputValue &&
          attrs.minValueValidator &&
          parseFloat(attrs.minValueValidator) < parseFloat(inputValue)
        ) {
          return false; //This is here to avoid the warning due to the amount
        }

        return true;
      };
    },
  };
}
